/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_MasterInputs */

const en_common_master = /** @type {(inputs: Common_MasterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Master`)
};

const de_common_master = /** @type {(inputs: Common_MasterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorlage`)
};

const fr_common_master = /** @type {(inputs: Common_MasterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Principal`)
};

const es_common_master = /** @type {(inputs: Common_MasterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Principal`)
};

const it_common_master = /** @type {(inputs: Common_MasterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Principale`)
};

const nl_common_master = /** @type {(inputs: Common_MasterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sjabloon`)
};

const pl_common_master = /** @type {(inputs: Common_MasterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Główne`)
};

const fi_common_master = /** @type {(inputs: Common_MasterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pääversio`)
};

const da_common_master = /** @type {(inputs: Common_MasterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skabelon`)
};

const sv_common_master = /** @type {(inputs: Common_MasterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Huvudversion`)
};

/**
* | output |
* | --- |
* | "Master" |
*
* @param {Common_MasterInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const common_master = /** @type {((inputs?: Common_MasterInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_MasterInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_common_master(inputs)
	if (locale === "fr") return fr_common_master(inputs)
	if (locale === "es") return es_common_master(inputs)
	if (locale === "it") return it_common_master(inputs)
	if (locale === "nl") return nl_common_master(inputs)
	if (locale === "pl") return pl_common_master(inputs)
	if (locale === "fi") return fi_common_master(inputs)
	if (locale === "da") return da_common_master(inputs)
	if (locale === "sv") return sv_common_master(inputs)
	return en_common_master(inputs)
});